import parse from "html-react-parser";

type BaseTextType = {
  text: string;
  customColor?: string;
  classProps?: string;
  padding?: string;
  textSize?: string;
  blockTextAnimation?: boolean;
  textColor?: string;
};

export default function BaseText(props: BaseTextType) {
  const options = {
    replace: (domNode: any) => {
      if (domNode.name === "strong") {
        return <span className="text-primary">{domNode.children[0].data}</span>;
      }
      return undefined;
    },
  };
  return (
    <p
      className={`font-medium font-text opacity-75 ${props.textSize ?? "text-base md:text-lg"} ${
        props.textColor ? props.textColor : "text-base-content"
      } ${props.customColor} ${props.classProps} ${props.padding ?? "py-4"}`}
    >
      {parse(props.text, options)}
    </p>
  );
}
